'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

// import videojs from 'video.js';
// import videojsvr from 'videojs-vr.js';


// estilos base de el vídeo


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

require('./videoPlayer.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoPlayer = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet,
    isApple: state.mobile.isApple
  };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VideoPlayer, _Component);

  function VideoPlayer(props, context) {
    (0, _classCallCheck3.default)(this, VideoPlayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VideoPlayer.__proto__ || (0, _getPrototypeOf2.default)(VideoPlayer)).call(this, props, context));

    _this.countPlay = 0;
    _this.count25 = 0;
    _this.count50 = 0;
    _this.count90 = 0;

    _this.player = null;
    _this.porcent25 = null;
    _this.porcent50 = null;
    _this.porcent75 = null;
    _this.porcent90 = null;

    _this.videoInitial = null;
    _this.playerType = 'vr';
    _this.iOS = false;

    _this.ended = _this.ended.bind(_this);
    _this.play = _this.play.bind(_this);
    _this.ready = _this.ready.bind(_this);
    _this.timeUpdate = _this.timeUpdate.bind(_this);
    _this.mountAudioDescription = _this.mountAudioDescription.bind(_this);
    _this.launchPlay = _this.launchPlay.bind(_this);
    _this.launchPause = _this.launchPause.bind(_this);
    _this.launchMuted = _this.launchMuted.bind(_this);
    _this.launchResetProgress = _this.launchResetProgress.bind(_this);

    _this.unmount = false;

    _this.videoContainer = _react2.default.createRef();

    _this.videoLoadPlay = false;
    return _this;
  }

  (0, _createClass3.default)(VideoPlayer, [{
    key: 'ended',
    value: function ended() {
      console.log("fin del vídeo");
      this.props.handleEndVideo();
    }
  }, {
    key: 'play',
    value: function play() {
      var _this2 = this;

      var _props = this.props,
          player = _props.player,
          indexSlider = _props.indexSlider,
          slickItemActive = _props.slickItemActive,
          anioActive = _props.anioActive,
          anioDelElemento = _props.anioDelElemento;
      // console.log("play antiguo");

      if (!this.porcent25) {
        this.porcent25 = 25 * this.player.duration() / 100;
        this.porcent50 = 50 * this.player.duration() / 100;
        this.porcent75 = 75 * this.player.duration() / 100;
        this.porcent90 = 90 * this.player.duration() / 100;
      }

      if (this.countPlay > 0 && indexSlider === slickItemActive && anioActive === anioDelElemento) {
        // if(this.countPlay === 0){
        // console.log("play video lanzamos datalayer");
        dataLayer.push({
          'event': 'PRIMER_PLAY',
          'origen': 'web',
          'title': this.props.titleVideo,
          'segment': '',
          'cdnHost': '',
          'programTitle': this.props.programTitle,
          'temporada': 'no aplica',
          'capitulo': '',
          'duration': this.props.duration,
          'categoriaCat': 'video vod',
          'channel': 'LAB'
        });
        this.countPlay = this.countPlay + 1;
      }

      if (this.countPlay <= 2) {
        if (player === '360' && this.playerType === 'panorama') {
          setTimeout(function () {
            $('.vjs-fullscreen-control').click();
          }, 0);

          setTimeout(function () {
            $('.vjs-fullscreen-control').click();
            _this2.player.play();
          }, 300);
          setTimeout(function () {
            _this2.player.play();
          }, 800);
        }
        this.countPlay = this.countPlay + 1;
      }
    }
  }, {
    key: 'timeUpdate',
    value: function timeUpdate() {
      // console.log("timeupdate");
      var currentTime = this.player.currentTime();
      if (this.player && this.porcent25) {
        if (this.count90 < 1 && currentTime >= this.porcent90) {
          this.count90 = 1;
          // console.log("llegado al 90%");
          dataLayer.push({
            'event': 'STOP_90',
            'origen': 'web',
            'title': this.props.titleVideo,
            'segment': '',
            'cdnHost': '',
            'programTitle': this.props.programTitle,
            'temporada': 'no aplica',
            'capitulo': '',
            'duration': this.props.duration,
            'categoriaCat': 'video vod',
            'channel': 'LAB'
          });
        } else if (this.count75 < 1 && currentTime >= this.porcent75) {
          this.count75 = 1;
          // console.log("llegado al 75%");
          dataLayer.push({
            'event': 'STOP_75',
            'origen': 'web',
            'title': this.props.titleVideo,
            'segment': '',
            'cdnHost': '',
            'programTitle': this.props.programTitle,
            'temporada': 'no aplica',
            'capitulo': '',
            'duration': this.props.duration,
            'categoriaCat': 'video vod',
            'channel': 'LAB'
          });
        } else if (this.count50 < 1 && currentTime >= this.porcent50) {
          this.count50 = 1;
          // console.log("llegado al 50%");
          dataLayer.push({
            'event': 'STOP_50',
            'origen': 'web',
            'title': this.props.titleVideo,
            'segment': '',
            'cdnHost': '',
            'programTitle': this.props.programTitle,
            'temporada': 'no aplica',
            'capitulo': '',
            'duration': this.props.duration,
            'categoriaCat': 'video vod',
            'channel': 'LAB'
          });
        } else if (this.count25 < 1 && currentTime >= this.porcent25) {
          this.count25 = 1;
          // console.log("llegado al 25%");
          dataLayer.push({
            'event': 'STOP_25',
            'origen': 'web',
            'title': this.props.titleVideo,
            'segment': '',
            'cdnHost': '',
            'programTitle': this.props.programTitle,
            'temporada': 'no aplica',
            'capitulo': '',
            'duration': this.props.duration,
            'categoriaCat': 'video vod',
            'channel': 'LAB'
          });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.indexSlider != prevProps.indexSlider || this.props.slickItemActive != prevProps.slickItemActive || this.props.anioActive != prevProps.anioActive || this.props.anioDelElemento != prevProps.anioDelElemento) {
        this.play();
      }
    }
  }, {
    key: 'ready',
    value: function ready() {
      var _props2 = this.props,
          vtt = _props2.vtt,
          handleReadyVideo = _props2.handleReadyVideo;
      // console.log("player ready eeeeeeee");

      if (vtt) {
        this.player.textTracks()[0].mode = 'disabled';
      }
      if (this.props.audioDescriptionSrc) {
        this.mountAudioDescription();
      }

      if (handleReadyVideo) {
        handleReadyVideo();
      }
    }
  }, {
    key: 'mountAudioDescription',
    value: function mountAudioDescription() {
      var _this3 = this;

      //on défini la différence entre les deux volumes
      var ratioVolume = 0;
      //on verifie si il y a bien un fichier d'audio-description

      var audioDescription = document.getElementById(this.props.idVideo + '-description');
      if (audioDescription) {
        //on ajoute le bouton
        //(this = le player videojs)
        // let button = this.player.controlBar.addChild('button');
        // button.el_.classList.add('vjs-icon-audio-description');

        var videoContainer = this.videoContainer.current;

        var button = document.createElement("button");
        button.classList.add('vjs-icon-audio-description');

        $(videoContainer).find('.vjs-control-bar').append(button);

        var videoBtnAudioDesription = $(this.videoContainer.current).find(".vjs-icon-audio-description");

        // this.player.controlBar.descriptionsButton.enabled_ = false
        // this.player.controlBar.descriptionsButton.el().classList.remove("vjs-hidden");
        // this.player.controlBar.descriptionsButton.el().classList.remove("vjs-disabled");
        // this.player.controlBar.descriptionsButton.el().removeAttribute("disabled");

        //on redéfini les volumes
        audioDescription.volume = 0;
        // player.volume( ratioVolume );

        //toggle sur le bouton pour "mute" l'audio-description ou non
        var audioDescriptionActive = false;

        videoBtnAudioDesription.on('click', function (e) {
          // this.player.controlBar.descriptionsButton.on('click', ( e ) => {
          e.preventDefault();
          console.log("click audio");
          if (audioDescriptionActive) {
            audioDescription.muted = true;
            audioDescriptionActive = false;
            audioDescription.volume = 0;
            // this.player.controlBar.descriptionsButton.el().classList.remove('vjs-icon-audio-description--active');
            videoBtnAudioDesription.removeClass('vjs-icon-audio-description--active');
          } else {
            audioDescription.muted = false;
            audioDescriptionActive = true;
            // this.player.controlBar.descriptionsButton.el().classList.add('vjs-icon-audio-description--active');
            videoBtnAudioDesription.addClass('vjs-icon-audio-description--active');
            if (_this3.videoInitial.muted) {
              audioDescription.volume = 0;
            } else {
              audioDescription.volume = Math.min(_this3.videoInitial.volume + ratioVolume, 1);
            }
          }
        });

        //play de la video => play sur l'AD
        this.player.on('play', function () {
          if (audioDescription.paused) {
            audioDescription.play();
          }
        });

        //pour sur la video => pause sur l'AD
        this.player.on('pause', function () {
          if (!audioDescription.paused) {
            audioDescription.pause();
          }
        });

        //fin de la video => pause sur l'AD
        this.player.on('ended', function () {
          _this3.player.pause();
          audioDescription.pause();
        });

        //synchro sur le volume
        this.player.on('volumechange', function () {
          if (audioDescriptionActive) {
            if (_this3.videoInitial.muted) {
              audioDescription.volume = 0;
            } else {
              audioDescription.volume = Math.min(_this3.videoInitial.volume + ratioVolume, 1);
            }
          }
        });

        //synchro sur le seek
        this.player.on('timeupdate', function () {
          if (audioDescription.readyState >= 4) {
            if (Math.ceil(audioDescription.currentTime) != Math.ceil(_this3.player.currentTime())) {
              audioDescription.currentTime = _this3.player.currentTime();
            }
          }
        });
      }
    }
  }, {
    key: 'launchPlay',
    value: function launchPlay() {
      this.player.play();
    }
  }, {
    key: 'launchPause',
    value: function launchPause() {
      this.player.pause();
    }
  }, {
    key: 'launchMuted',
    value: function launchMuted(boolean) {
      this.player.muted(boolean);
    }
  }, {
    key: 'launchResetProgress',
    value: function launchResetProgress() {
      this.player.currentTime(0);
    }
  }, {
    key: 'loadVideo',
    value: function loadVideo() {
      // console.log("loadVideo " + this.props.idVideo + " this.videoLoadPlay " + this.videoLoadPlay );
      if (!this.videoLoadPlay) {
        this.videoLoadPlay = true;
        this.launchPlay();
        this.launchPause();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      this.props.onRef(this);

      if (typeof this.props.onRef === 'function') {
        this.props.onRef(this);
      }
      var _props3 = this.props,
          player = _props3.player,
          vtt = _props3.vtt;


      this.unmount = false;
      // console.log("VideoPlayer lanza componentDidmount");
      setTimeout(function () {
        if (!_this4.unmount) {

          _this4.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

          _this4.videoInitial = document.getElementById(_this4.props.idVideo);

          _this4.player = window.player = videojs(_this4.props.idVideo, {});

          if (player === '360') {
            _this4.player.mediainfo = _this4.player.mediainfo || {};
            _this4.player.mediainfo.projection = '360';
            // AUTO is the default and looks at mediainfo

            if (_this4.iOS) {
              _this4.playerType = 'panorama';
              // con panorama
              _this4.player.panorama({
                clickAndDrag: true,
                callback: function callback() {
                  player.play();
                }
              });
            } else {
              // con vr
              var vr = window.vr = _this4.player.vr({
                projection: 'AUTO',
                debug: false,
                forceCardboard: false
              });
            }
          }

          _this4.player.on('ready', function () {
            _this4.ready();
          });

          _this4.player.on('ended', function () {
            //Llega al final del vídeo
            _this4.ended();
          });

          _this4.player.on('play', function () {
            // console.log("player play eeeeeeee");
            _this4.play();
          });

          _this4.player.on('timeupdate', function () {
            _this4.timeUpdate();
          });
        }
      }, 2000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
      // console.log("VideoPlayer lanza componentWillUnmount");
      //desmontamos video
      if (this.player) {
        this.player.dispose();
      }
      this.unmount = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          idVideo = _props4.idVideo,
          urlVideoDesktop = _props4.urlVideoDesktop,
          urlVideoMobile = _props4.urlVideoMobile,
          vtt = _props4.vtt,
          audioDescriptionSrc = _props4.audioDescriptionSrc,
          videoType = _props4.videoType,
          poster = _props4.poster;


      var videoLocalMp4 = urlVideoMobile;
      if (!this.props.isMobile) {
        videoLocalMp4 = urlVideoDesktop;
      }

      var vttHtml = null;
      if (vtt) {
        vttHtml = _react2.default.createElement('track', { kind: 'captions', src: vtt, srcLang: 'es', label: 'Espa\xF1ol', 'default': true });
      }

      var videoRecurso = _react2.default.createElement(
        'video',
        { id: idVideo, className: 'videoInCarousel video-js vjs-default-skin vjs-user-inactive', crossOrigin: 'anonymous', muted: true, controls: true, playsInline: true, poster: this.context.baseUrl + poster },
        _react2.default.createElement('source', { src: videoLocalMp4, type: videoType }),
        vttHtml
      );

      // let videoRtve = (
      //   <video id="videojs-vr-player" className="video-js vjs-default-skin vjs-user-inactive" controls playsInline>
      //     <source src="http://hlsvod.lvlt.rtve.es/resources/TE_NGVA/mp4/appsvideos/apps_escena/goya1/resumengala_hd.mp4/playlist.m3u8" />
      //     <track kind="captions" src="http://www.rtve.es/resources/vtt/6/2/1548371716426.vtt" srcLang="es" label="Español" default />
      //   </video>
      // );

      // let videoLocal = (
      //   <video  id="videojs-vr-player2" className="video-js vjs-default-skin vjs-user-inactive" controls playsInline>
      //     <source src={this.context.baseUrl + '/media/video/'+ videoLocalMp4 } type="video/mp4" />
      //     <track kind="captions" src={this.context.baseUrl + '/media/video/elcano360.vtt'} srcLang="es" label="Español" default />
      //   </video>
      // );

      // let videoLocal2 = (
      //   <video  id="videojs-vr-player2" className="video-js vjs-default-skin vjs-user-inactive" controls playsInline>
      //     <source src={this.context.baseUrl + '/media/video/eagle-360.mp4'} type="video/mp4" />
      //     <track kind="captions" src={this.context.baseUrl + '/media/video/elcano360.vtt'} srcLang="es" label="Español" default />
      //   </video>
      // );

      var audioDescriptionHtml = null;

      if (audioDescriptionSrc) {
        audioDescriptionHtml = _react2.default.createElement(
          'audio',
          { id: idVideo + "-description", className: 'video-js-audio vjs-default-skin sr-only', muted: true, controls: true, preload: 'auto' },
          _react2.default.createElement('source', { src: audioDescriptionSrc, type: 'audio/mp3' })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'videoPlayerContainer', ref: this.videoContainer },
        videoRecurso,
        audioDescriptionHtml
      );
    }
  }]);
  return VideoPlayer;
}(_react.Component), _class2.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  project: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = VideoPlayer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoPlayer/VideoPlayer.jsx
// module id = 710
// module chunks = 0